import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { IconButton, MenuItem } from 'material-ui';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import ControlPointIcon from 'material-ui/svg-icons/image/control-point';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';

const styles = {
    textField: {
        floatingLabelStyle: { fontSize: '12px' },
    },
    icon: {
        color: 'rgb(0, 188, 212)',
    },
};

const validatePhone = (phone) => {
    if (!phone) return 'Required';
    if (!/^\d+$/.test(phone)) return 'Must be a number';
    if (phone.length < 7 || phone.length > 15) return 'Must be between 7 and 15 digits';
    return '';
};

const Phones = ({ 
    phones = [{ code: '', phone: '' }],
    onChange,
    error,
    countries,
}) => {
    const filteredCountries = useMemo(
        () => countries.filter(country => country.phoneCode && country.phoneCode[0]),
        [countries],
    );

    const addPhone = () => {
        onChange([...phones, { code: '', phone: '' }]);
    };

    const removePhone = (index) => {
        const newPhones = phones.filter((_, i) => i !== index);
        onChange(newPhones);
    };

    const handlePhoneChange = (index, field, value) => {
        const newPhones = [...phones];
        newPhones[index] = {
            ...newPhones[index],
            [field]: value,
        };
        onChange(newPhones);
    };

    return (
        <React.Fragment>
            {phones.map((phone, index) => (
                <div className="row" key={index}>
                    <div className="col-xs-4">
                        <SelectField
                            value={phone.code}
                            onChange={(e, i, value) => handlePhoneChange(index, 'code', value)}
                            floatingLabelText='Country'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            fullWidth
                            autoWidth
                            errorText={!phone.code ? 'Required' : ''}
                        >
                            {filteredCountries.map((country, key) => (
                                <MenuItem
                                    key={key}
                                    value={country.phoneCode[0]}
                                    primaryText={`${country.phoneCode[0]} ${country.name}`}
                                />
                            ))}
                        </SelectField>
                    </div>
                    <div className="col-xs-6">
                        <TextField
                            value={phone.phone}
                            onChange={e => handlePhoneChange(index, 'phone', e.target.value)}
                            floatingLabelText='Phone number'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            fullWidth
                            errorText={validatePhone(phone.phone)}
                        />
                    </div>
                    <div className="col-xs-2 center-xs middle-xs" style={{ display: 'flex' }}>
                        {index === 0 ? (
                            <IconButton
                                iconStyle={styles.icon}
                                onClick={addPhone}
                            >
                                <ControlPointIcon />
                            </IconButton>
                        ) : (
                            <IconButton
                                iconStyle={styles.icon}
                                onClick={() => removePhone(index)}
                            >
                                <ContentRemoveIcon />
                            </IconButton>
                        )}
                    </div>
                </div>
            ))}
        </React.Fragment>
    );
};

Phones.propTypes = {
    phones: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string,
        phone: PropTypes.string,
    })),
    onChange: PropTypes.func.isRequired,
    error: PropTypes.string,
    countries: PropTypes.arrayOf(PropTypes.shape({
        phoneCode: PropTypes.arrayOf(PropTypes.string),
        name: PropTypes.string.isRequired,
    })).isRequired,
};

export default Phones;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/Phones.jsx